<template>
  <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="checked" @change="changes" />
</template>

<script>
import { onMounted, ref, watch, watchEffect } from "vue";
export default {
  name: "customizeSwitch",
  props: {
    value: Number,
  },
  setup(props, { emit }) {
    const checked = ref(0);
    watchEffect(()=>{
        checked.value=props.value
    })
    const changes = (e) => {
      emit("update:value", e );
    };
    return {
      checked,
      changes,
    };
  },
};
</script>